import React from 'react'

const SuccessfullGuias = () => {
    return (
        <div>SuccessfullGuias</div>
    )
}

export default SuccessfullGuias